import { hasProperty } from '@fmnts/core';
import {
  ISelectInputField,
  SelectInputField,
  WidgetType,
} from '../model/form-field';

export function isInputField(
  widget: WidgetType | undefined,
): widget is 'input' {
  return widget === 'input';
}

// Helper to check if there is a property items of type array.
const hasItemsArrayProp = hasProperty('items', (x: unknown): x is unknown[] =>
  Array.isArray(x),
);

/**
 * Checks whether the widget options for a field are `SelectInputField` widget options.
 * @param widgetOptions
 * @returns
 */
export function isSelectInputField(
  widgetOptions: unknown,
): widgetOptions is ISelectInputField {
  return (
    widgetOptions instanceof SelectInputField ||
    hasItemsArrayProp(widgetOptions)
  );
}

export function isTextboxField(
  widget: WidgetType | undefined,
): widget is 'textbox' {
  return widget === 'textbox';
}

export function isActionField(
  widget: WidgetType | undefined,
): widget is 'action' {
  return widget === 'action';
}
